export default {
	comments: {
		confirm_delete_comment: 'Do you really want to delete this comment?',
	},
}
